import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  // The PRD's tier pill: the plan's name in the brand colour on its tint, with the info icon inside the pill's end.
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    flexShrink: 0,
    padding: '1px 2px 1px 10px',
    borderRadius: '999px',
    backgroundColor: alpha(palette.primary.main, 0.1),
    color: palette.primary.dark,
    fontSize: '0.8125rem',
    fontWeight: 600,
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    verticalAlign: 'middle'
  },
  tip: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  },
  tipTitle: {
    fontWeight: 600
  },
  // "Upgrade now" beside a lock (LB-6187): a text button no taller than the badge, so a table row keeps its height.
  upgradeButton: {
    minWidth: 0,
    padding: '0 6px',
    lineHeight: 1.6,
    whiteSpace: 'nowrap'
  },
  // "Upgrade requested", and staff's "Customers see Upgrade now", in its place.
  upgradeNote: {
    color: palette.shades[700],
    fontSize: '0.8125rem',
    whiteSpace: 'nowrap'
  },
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    minWidth: 0
  },
  // The plan and what it includes, as the badge's tip says it.
  tierBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    border: "1px solid ".concat(palette.shades[400]),
    borderRadius: '8px',
    padding: '8px 12px',
    backgroundColor: alpha(palette.primary.main, 0.06)
  },
  terms: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }
});
export default useStyles;